<template>
  <div v-if="this.$isMobile()">
    <v-parallax dark src="../assets/ImpresaEdileBPParallaxSmartphone.jpg" style="height: 650px;"> 
      <v-row align="end" justify="center" class="d-flex flex-wrap text-center">
        <v-col cols="12" class="mb-4">
          <h4 class="font-weight-bold mb-4">
            {{title}}
          </h4>
          <Label class="subheading font-weight-light w3-serif mb-4">
            {{firstParagraph}}
          </Label>
            <v-btn :onclick="button.href" rounded color="smartphone-background-color" dark :width="button.width">  
              <span class="material-icons pr-3" style="color: black !important;">{{button.icon}}</span>
              <span style="color: black !important;">{{button.text}}</span>
            </v-btn>
        </v-col>
      </v-row>
    </v-parallax>
  </div>
  <div v-else>
    <v-parallax dark src="../assets/ImpresaEdileBPParallax.jpg">
      <v-row align="center" justify="center" class="d-flex flex-wrap">
        <v-col cols="6"></v-col>
        <v-col cols="6" class="mt-16">
          <h1 class="display-1 font-weight-bold mb-4">
            {{title}}
          </h1>
          <h4 class="subheading font-weight-light w3-serif mb-8">
            {{firstParagraph}}
          </h4>
          <br>
          <v-row justify="center">
            <v-btn :onclick="button.href" rounded color="primary" dark :width="button.width">  
              <span class="material-icons pr-3">{{button.icon}}</span>
              <span>{{button.text}}</span>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-parallax>
  </div>
</template>

<script>
  export default {
    name: 'ImpresaEdileBP',
    data: () => ({
      title: "Edilizia civile, industriale e ristrutturazione edifici",
      firstParagraph: "L’Impresa Edile di Baldassarri C. & Pace G. S.r.l. è un’impresa specializzata nella manutenzione ordinaria e straordinaria, nella ristrutturazione, nel consolidamento, nel recupero e nel restauro conservativo e nella realizzazione di nuove costruzioni.",
      button: {
        href: "window.location.href='tel:3357031889'",
        width: "200px",
        icon: "call",
        text: "Chiama ora",
      }
    }),
  }
</script>

